import React from 'react'

interface CityStateProps {
  city: string | null
  fontSize?: string
  state: string | null
}

const fontSizeClasses: Record<string, string> = {
  lg: 'text-lg',
  md: 'text-base',
  sm: 'text-sm'
}

/**
 * The city/state label for a stop
 */
export const CityState = (props: CityStateProps) => {
  const { city, state, fontSize = 'sm' } = props

  return <span className={`font-semibold ${fontSizeClasses[fontSize]}`}>{city ? city + ', ' + state : '-'}</span>
}
